import Caption from '@algbra/ui/components/Caption/Caption'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Container } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Icon from '@algbra/ui/components/Icon/Icon'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { getIconByName } from '@algbra/ui/icons'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import classNames from 'classnames'
import { includes, mapIndexed } from 'rambdax'
import { useState } from 'react'

import styles from './FaqBox.module.scss'
import { Link } from 'gatsby'

export type FAQItem = {
  id: string
  question: string
  answer: GatsbyResolvedAsset
}

export type ZoneFaqBoxProps = {
  __typename: 'StrapiGQL_ComponentZonesFaqBox'
  faqTitle: string
  faqItem?: FAQItem[]
  faqTheme?: 'faqPage'
  viewAllLink?: string
}

export function FaqItem({ id, question, answer }: FAQItem): JSX.Element {
  const [isOpen, setOpen] = useState<boolean>(false)
  const iconName = isOpen ? 'arrow-up' : 'arrow-down'
  return (
    <div
      className={classNames(styles.faqItem, isOpen ? styles.faqItemOpen : '')}
      onClick={() => setOpen(!isOpen)}
    >
      <div className={styles.faqQuestion}>
        <Caption type="md" className={styles.question}>
          {question}
        </Caption>
        <Icon
          icon={getIconByName(iconName)}
          className={styles.icon}
          size={18}
        />
      </div>
      <div
        className={styles.faqAnswer}
        style={{ display: isOpen ? 'block' : 'none' }}
      >
        <FreeText
          className={styles.answer}
          color="secondary"
          type="m"
          innerHTML={answer}
        >
          {answer}
        </FreeText>
      </div>
    </div>
  )
}

export default function ZoneFaqBox({
  faqTitle,
  faqItem,
  faqTheme,
  viewAllLink,
}: ZoneFaqBoxProps) {
  return (
    <Whitespace type={faqTheme === 'faqPage' ? 'md' : 'lg'}>
      <Container>
        <div
          className={classNames(
            styles.faqContainer,
            styles[`theme__${faqTheme}`]
          )}
        >
          <Heading className={styles.faqTitle}>{faqTitle}</Heading>
          {mapIndexed(
            (faq: FAQItem, index) => (
              <FaqItem {...faq} key={faq.id} />
            ),
            faqItem
          )}
          {viewAllLink && (
            <Link
              to={viewAllLink}
              target={includes('http', viewAllLink) ? '_blank' : '_self'}
              className={styles.link}
            >
              <span>View all questions</span>
              <Icon icon={getIconByName('arrow-right')} size={24} />
            </Link>
          )}
        </div>
      </Container>
    </Whitespace>
  )
}
